import Mapper from '@/models/mappers/Mapper';
import { Color } from '@/models/entities/Color';
import { ColorDTO } from '@/api/dto/ColorDTO';
import { mapValueToInterface } from '@/utils/models';

export class ColorMapper extends Mapper<Color, ColorDTO> {
  mapFromDTO(colorDTO: ColorDTO): Color {
    return new Color(<Partial<Color>>colorDTO);
  }

  mapToDTO(color: Color): ColorDTO {
    return mapValueToInterface(color) as ColorDTO;
  }
}
